export const MODAL_STATE_IN_PROGRESS = 'IN_PROGRESS' as const;
export const MODAL_STATE_SUCCESS = 'SUCCESS' as const;
export const MODAL_STATE_FAIL = 'FAIL' as const;

export type ModalState =
	| typeof MODAL_STATE_IN_PROGRESS
	| typeof MODAL_STATE_SUCCESS
	| typeof MODAL_STATE_FAIL;
